import * as turf from '@turf/turf'
import type { Geometry } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

const VALIDATED_PERIMETER_COLOR = 'hsl(61, 90%, 71%)'

// PUT /v1/farms/:id/validate answers a message-only envelope (no payload).
export const validatePerimeter = async ({
  id,
  geometry,
  originalGeometry,
  dryRun,
  overrideEdition,
}: {
  id: string
  geometry: Geometry
  originalGeometry: Geometry
  dryRun: boolean
  overrideEdition: boolean
}): Promise<void> => {
  const center = turf.center(geometry).geometry.coordinates
  const response = await apiClient.put(
    `${endpoints.farms}/${id}/validate?dryRun=${dryRun}&overrideEdition=${overrideEdition}`,
    {
      id,
      data: {
        perimeter: geometry,
        originalPerimeter: originalGeometry,
        // Deliberate correction: turf.center returns [lng, lat], and the v1 validate handler
        // ignores lat/lng today.
        lat: center[1],
        lng: center[0],
        color: VALIDATED_PERIMETER_COLOR,
      },
    },
  )
  return unwrapVoid(response)
}
